import CultureFlag from "components/Culture/CultureFlag";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import SmallDetails from "components/SmallDetails/SmallDetails";
import Tag from "components/Tag/Tag";
import TwoColumnLayout from "layout/TwoColumnLayout";
import moment from "moment";
import React from "react";
import { getFilterSet, mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useLoaderData } from "react-router";
import { routes } from "utilities/routing/generatedRoutes";

const ExcelTemplateListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ExcelTemplateListFrontModel>();

  const filterSet = getFilterSet(viewModel.mainAreaId);

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet={filterSet}
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={{ ...viewModel.initialInstruction, mainArea: viewModel.mainAreaId }}
        fetchFunction={window.CoreApi.ExcelTemplate.Paginated}
        getId={item => item.excelTemplateId}
        onNew={() => window.location.href = routes.excelTemplate_New(viewModel.mainAreaId).absolute}
        layout={{
          type: "table",
          columns: [
            { header: "", size: "52px", key: "flag", render: item => <CultureFlag lcid={item.lcid} /> },
            {
              header: RESX.GeneralLabels.Title, key: "title", render: item => <SmallDetails
                link={routes.excelTemplate_Detail(item.excelTemplateId).absolute}
                label={item.title}
                subLabel={`${item.columns.length} ${RESX.Template.Columns}`}
              />
            },
            { header: "", key: "distinctRows", render: (item) => item.distinctRows && <Tag color="blue" label={RESX.ExcelTemplate.UniqueRows} /> },
            { header: RESX.GeneralLabels.LastModified, key: "lastModified", render: item => moment.utc(item.lastModifiedUtc).fromNow() },
          ]
        }}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction: (filterSet, filter, page, perPage) => mapFilterValuesToInstruction(viewModel.mainAreaId, filterSet, filter, page, perPage)
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
};


export default ExcelTemplateListApp;